export default __webpack_public_path__ + "static/media/FlatIcon.e145440d.svg";